import axios from 'axios'
import Errors from '@/utils/auth-errors.js'

const namespaced = true

const state = {
	access_token: null,
	status: '',
	hasLoadedOnce: false,
	errors: null,
	previousEmail: '',
	user: null
}

const getters = {
	user: state => state.user,
	userName: state => state.user ? state.user.name : '',
	access_token: state => state.access_token,
	isAuthenticated: state => !!state.access_token && state.user !== null,
	authStatus: state => state.status,
	authErrors: state => state.errors,
	previousEmail: state => state.previousEmail,
}

const actions = {

	AUTH_REQUEST({ commit, dispatch }, payload) {
		return new Promise((resolve, reject) => {
			commit('authRequest');
			axios.post('auth/login', {
				email: payload.email,
				password: payload.password,
				device_name: 'print-app'
			}).then((response) => {
				let access_token = 'Bearer ' + response.data;
				axios.defaults.headers.common['Authorization'] = access_token;

				commit('authSuccess', {access_token: access_token, email: payload.email});
				dispatch('FETCH_USER').then(() => {
					resolve(access_token);
				});
			})
			.catch((err) => {
				commit('authError', err.response.data);
				reject(err);
			})
		})
	},

	AUTH_LOGOUT({ commit, dispatch }) {
		return new Promise((resolve, reject) => {
			commit('setUser', null);
			axios.post('auth/logout')
				.then((response) => {
					commit('authLogout');
					resolve();
				})
				.catch((err) => {
					commit('authLogout');
					resolve();
				});
		})
	},

	FETCH_USER({ commit, dispatch }) {
		return new Promise((resolve, reject) => {
			axios.get('auth/user')
				.then((response) => {
					commit('setUser', response.data);
					resolve();
				})
				.catch((err) => {
					commit('authLogout');
					resolve();
				});
		})
	}
}

const mutations = {
	authRequest: (state) => {
		state.status = 'loading';
	},

	authSuccess: (state, {access_token, email}) => {
		state.status = 'success';
		state.access_token = access_token;
		state.hasLoadedOnce = true;
		state.previousEmail = email;
		state.errors = null
	},

	authError: (state, err) => {
		let errors = err.errors ? err.errors : {};
		if (err.error == "invalid_credentials") {
			errors.invalid_credentials = ['The user credentials were incorrect.'];
		}

		state.access_token = null;
		state.status = 'error';
		state.hasLoadedOnce = true;

		state.errors = new Errors()

		state.errors.record(errors);
	},

	authLogout: (state) => {
		state.access_token = null;
		state.user = null
	},

	setUser: (state, user) => {
		state.user = user
	}
}

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions
}
